export const LEAFLET_TILE_LAYER_OPTIONS = {
  subdomains: 'abcd',
  attribution:
    'Maps &copy; <a href="https://www.thunderforest.com">Thunderforest</a>, Data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
};
